import type { QueryInput } from "@/models/compound";
import { LoadingStrategy } from "@/algorithms/loadingStrategies/LoadingStrategy";

export class RandomSelection extends LoadingStrategy {
  getQueryInputs(
    identifier: string,
    maxObjectReturn: number,
    onlyNewElements: boolean
  ): QueryInput[] {
    const warehouseData = this.getWarehouseData(identifier);
    if (undefined === warehouseData) return [] as QueryInput[];

    const { newFilenames, startedFilenames } = this.getNewAndStartedFilenames(
      warehouseData.progress
    );

    // Randomly, pick a given number of filenames
    const joinedFilenames = onlyNewElements
      ? [...newFilenames]
      : [...startedFilenames, ...newFilenames];

    const pickedFilenames: string[] = [];
    while (
      pickedFilenames.length < Math.min(joinedFilenames.length, maxObjectReturn)
    ) {
      const randomIndex = Math.floor(Math.random() * joinedFilenames.length);
      const filename = joinedFilenames[randomIndex];
      if (!pickedFilenames.includes(filename)) pickedFilenames.push(filename);
    }

    return this.createQueryInputObjects(
      identifier,
      warehouseData,
      maxObjectReturn,
      pickedFilenames
    );
  }
}
